import api from '../../../common/api.js'
import createCSVFile from '../../../common/createCSVFile.js'
import {getNounsFromValue} from '../../../common/tokenizeOptions.js'
import {useSelector} from '../../../store.js'
import {
  columnOptionsSelector,
  columnOptionsToHeaders,
  processFiles,
  simpleColumnOptionsToRowArray,
} from '../dataImportFunctions.js'
import Header from '../Header.js'
import {COLUMN_OPTIONS as PRODUCT_CREATE_COLUMN_OPTIONS} from './ProductCreateImport.js'

const TYPE = 'update_products'
const COLUMN_OPTIONS = PRODUCT_CREATE_COLUMN_OPTIONS.map((option) => {
  if (option.value === 'name') {
    return {...option, required: false, error: undefined}
  }

  return option
})

async function createExampleFile(columnOptions) {
  const {json: data} = await api.get('/product/', {limit: 5})

  const headers = columnOptionsToHeaders(columnOptions)

  const rows = simpleColumnOptionsToRowArray(columnOptions, data.product)

  createCSVFile(headers, rows, 'Update_Product-example.csv')
}

function ProductUpdateImport({importOptions}) {
  const columnOptions = useSelector((state) =>
    columnOptionsSelector(state, {columnOptions: COLUMN_OPTIONS}),
  )

  return (
    <div>
      <Header
        importOptions={importOptions}
        processFiles={(files) => processFiles(columnOptions, files)}
        createExampleFile={() => createExampleFile(columnOptions)}
        columnOptions={columnOptions}
        type={TYPE}
      />
    </div>
  )
}

const option = {
  value: TYPE,
  display: 'Update Product',
  category: 'products',
  Component: ProductUpdateImport,
}
option.nouns = getNounsFromValue(
  `${option.value} ${option.display} ${option.category}`,
)
ProductUpdateImport.option = option

export default ProductUpdateImport
